import React from 'react'
import { List, ListItem } from 'Lib/List'
import SectionHeader from 'Lib/Text/SectionHeader'
import { Truncate } from 'Lib/Text'
import Trips from 'Components/Home/icons/trips.svg'
import { TRIPS_NOT_AVAILABLE_MESSAGE } from 'AccountsConstants/language/trips'

const NoTripsAvailable = ({ loggedIn }) => {
  const noTrips = (
    <List className="amt-10">
      <ListItem arrow={false} enableRipple={false}>
        <div className="flag h-15">
          <div className="flag__fix amr-15">
            <Trips fill={loggedIn ? '#36c' : '#999'} width="36px" height="36px" />
          </div>
          <div className="flag__flex">
            <h5 className="fs-17 lh-solid c-black-80">{TRIPS_NOT_AVAILABLE_MESSAGE}</h5>
            <Truncate className="fs-14 lh-copy c-black-50" width="98%">
              You need to be signed in to view bookings
            </Truncate>
          </div>
        </div>
      </ListItem>
    </List>
  )

  return (
    <div>
      <If condition={!loggedIn}>
        <SectionHeader marginTop="20">Bookings</SectionHeader>
      </If>
      <div style={loggedIn ? { opacity: '1' } : { opacity: '0.7' }}>{noTrips}</div>
    </div>
  )
}

export default NoTripsAvailable
